import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLazySetProvidersQuery } from "../../../Store/Builder/techsbook.api";
import { setLoader, setUserData } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";
import useGetAccountApi from "../Account/getAccountApi";

const useSetProvidersApi = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [providersApi] = useLazySetProvidersQuery();
  const getAccountApi = useGetAccountApi();
  const send = (data, setModal) => {
    dispatch(setLoader(true));
    providersApi(data)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setUserData(res?.account));
        showToast(res?.message ?? "Success", "success");
        getAccountApi.get();
        setModal ? setModal(false) : navigate("/");
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useSetProvidersApi;
